export const LOCALE_KEY = 'global-notification';
